import { render } from "./StaticImage.vue?vue&type=template&id=130cfd6e&scoped=true"
import script from "./StaticImage.vue?vue&type=script&lang=js"
export * from "./StaticImage.vue?vue&type=script&lang=js"

import "./StaticImage.vue?vue&type=style&index=0&id=130cfd6e&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130cfd6e"]])

export default __exports__